<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.last_name"
        placeholder="Surname"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.first_name"
        placeholder="Given name"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.uuid"
        placeholder="UUID"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.address"
        placeholder="Address"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.is_submit"
        placeholder="1099"
        clearable
        style="width: 200px"
        class="filter-item"
      >
        <el-option label="YES" value="1" />
        <el-option label="NO" value="0" />
      </el-select>
      <el-date-picker
        class="filter-item"
        v-model="listQuery.date"
        type="daterange"
        @change="changedata"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
        range-separator="to"
        start-placeholder="Start date"
        end-placeholder="End date"
      >
      </el-date-picker>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >search</el-button
      >
      <download-excel
        class="filter-item"
        :fields="json_fields"
        :fetch="handleExport"
        type="xls"
        name="Financial Statement.xls"
        worksheet="Financial Statement"
      >
        <el-button type="success" :loading="exportLoading">
          Export Financial Statement
        </el-button>
      </download-excel>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column align="center" label="UUID" width="120">
        <template slot-scope="scope">
          {{ scope.row.uuid }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="Surname" width="120">
        <template slot-scope="scope">
          {{ scope.row.last_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Given name" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.first_name || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Total Bouns" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_bouns || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Spent GP" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.spent_gp || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Withdrawn" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.withdrawn_balance || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Remaining Bouns" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.remaining_bouns || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="Address" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.address || '-' }}
        </template>
      </el-table-column>

      <el-table-column label="1099" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.is_submit == 1 ? 'success' : 'warning'"
            >{{ scope.row.is_submit == 1 ? 'YES' : 'NO' }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column
        label="操作"
        align="center"
        min-width="230"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="edit(scope.row)">
            详情
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import downloadExcel from 'vue-json-excel'
export default {
  components: { downloadExcel },
  data() {
    return {
      rejectModalVisible: false,
      rejectRules: {
        reason: [
          { required: true, message: '请填写驳回理由', trigger: 'blur' },
        ],
      },
      rejectForm: {
        id: '',
        reason: '',
      },
      list: null,
      total: null,
      listLoading: false,
      exportLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        user_id: '',
        username: '',
        email: '',
        vip_level_no: '',
        revenue_type: '',
        start_at: '',
        end_at: '',
        is_active: '',
      },
      viplist: [],
      json_fields: {
        UUID: {
          field: 'uuid',
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        Surname: {
          field: 'last_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        'Given name': {
          field: 'first_name',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        'Total Bouns': {
          field: 'total_bouns',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        'Spent GP': {
          field: 'spent_gp',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        Withdrawn: {
          field: 'withdrawn_balance',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        'Remaining Bouns': {
          field: 'remaining_bouns',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        Address: {
          field: 'address',
          //自定义回调函数
          callback: (value) => {
            return '<p style="mso-number-format:\'\\@\';">' + value + '</p>'
          },
        },
        1099: {
          field: 'is_submit',
          //自定义回调函数
          callback: (value) => {
            return value == 1 ? 'YES' : 'NO'
          },
        },
      },
    }
  },
  created() {
    this.vipLevelConfigs()
    this.getList()
  },
  watch: {
    rejectModalVisible() {
      this.rejectForm = {
        ...this.rejectForm,
        reason: '',
      }
    },
  },
  computed: {
    vip_status() {
      return (val) => {
        switch (val) {
          case 'active':
            return 'VIP 已激活'
          case 'inactive':
            return 'VIP 未激活'
          case 'inactive_affiliate':
            return 'VIP 未激活-网红'
          case 'never_purchased':
            return '非VIP'
        }
      }
    },
  },
  methods: {
    vipLevelConfigs() {
      request({
        url: '/api/backend/dataCount/vipLevelConfigs',
        method: 'get',
        params: this.listQuery,
      }).then((res) => {
        console.log(res)
        if (res.code == 0) {
          this.viplist = res.data
        }
      })
    },
    changedata(val) {
      console.log(val)
      if (val) {
        this.listQuery.statement_start_at = val[0] + ' 00:00:00'
        this.listQuery.statement_end_at = val[1] + ' 23:59:59'
      } else {
        this.listQuery.statement_start_at = ''
        this.listQuery.statement_end_at = ''
      }
    },
    handleExport() {
      if (
        !this.listQuery.statement_start_at ||
        !this.listQuery.statement_end_at
      ) {
        this.$message.warning('请选择开始与结束日期')
        return
      }
      this.exportLoading = true
      var listQuery = JSON.parse(JSON.stringify(this.listQuery))
      return request({
        url: '/api/backend/users',
        method: 'get',
        params: {
          ...listQuery,
          page: 1,
          limit: 100000,
        },
      })
        .then((response) => {
          console.log(response)
          return response.data.data
        })
        .finally((val) => {
          console.log(val)
          this.exportLoading = false
        })
    },
    getList() {
      this.listLoading = true
      request({
        url: '/api/backend/users',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    edit(val) {
      this.$router.push('/member/editmemberinfo')
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
</style>
